import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  changeHistoryButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0.75rem 1rem',
    border: `1px solid ${theme.palette.grey[300]}`,
    cursor: 'pointer',
    marginTop: '0.125rem',
  },
  changeHistoryButtonTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  changeHistoryButtonTitleIcon: {
    fontSize: 16,
    marginRight: '0.5rem',
  },
  changeHistoryIcon: {
    fontSize: 24,
  },
}));
